export default __webpack_public_path__ + "static/media/icon_telephone.98758038.svg";